import services from './../../services/service'; // Service Class
import Settings from './../../components/tools/settings.vue';
import LogoPad from '../../components/templates/logo-pad.vue'
import AccountDropMenu from '../../components/templates/account-menu.vue'
let service = new services();

export default {
  name: "MainHeader",
  data() {
      return {
        path: (this.$route.path).replace('/',''),
        user: {},
        user_slug: {},
        market:{},
        products: {},
        product: {},
        items:[],
        checked_out_items: [],
        img_url: service.imageURL,
        loggedIn:false,
        server_query_done:false,
        show_back:true,
      }
  },
  
  components: {
    'c-settings':Settings,
    'logo-pad': LogoPad,
    'component-account-menu': AccountDropMenu,
},
methods: {
    back(){
        window.history.back();
    },
    
    display_menu(){
        let status = document.getElementById("main-nav-bar").style.display;
        if(status == "none"){
            document.getElementById("main-nav-bar").style.display = "block";
        }else{
            document.getElementById("main-nav-bar").style.display = "none";
        }
        
    },

    checkLoggedIn(){
        if(localStorage.getItem("sp_token") != null){
            this.loggedIn = true;
            this.user = localStorage.getItem("sp_user");
        }
    },

    preset() {
        var credentials = {
            session_key: localStorage.getItem("sp_token")
        } 
        if(credentials.session_key != null) {
            service.sessionGuard(this, credentials).then(response => {
                if(response.body.status == 200) {
                    this.server_query_done = true;
                    let data = response.body.data;
                    data.forEach(function(element) {
                        this.user.user_id = element.user_id;
                        this.user.user_name = localStorage.getItem("sp_user");
                        this.loggedIn = true;//loggedIn options
                    }, this);
                }else {
                  //  console.log(response)
                 //// this.$router.push('/login/');
                  }
                  this.server_query_done = true;
            }).catch((err) => {
                if(err) {
                    this.server_query_done = true;
                    // console.log(err)
                    //this.$router.push('/login/');
                }
            })
        }else {
           //console.log("error 2")
          // this.$router.push('/login/');
          this.server_query_done = true;
        }
    },

    setMarketRemote(){
        service.getBusinessByUserName(this, "").then(response => {
            if(response.body.status == 200) {
                this.market = response.body.data;
            }
        }).catch((err) => {
            //maybe no connection ..load from local
           // this.setSellpointLocal(); //removed...caused slower loading
        })
        
    },


    setMarketLocal(){},

    setPageHeaders(){
        // When the user scrolls the page, execute myFunction
        window.onscroll = function() {
            // Get the header
            var stick_header = document.getElementById("pageStickyHeader");

            // Get the offset position of the navbar
            var sticky = stick_header.offsetTop;

            // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
            if (window.pageYOffset > sticky) {
                stick_header.classList.add("header-sticky");
            } else {
                stick_header.classList.remove("header-sticky");
            }
        };
    },

    setStickyHeader() {
        // Get the header
        var stick_header = document.getElementById("pageStickyHeader");

        // Get the offset position of the navbar
        var sticky = stick_header.offsetTop;

        // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
        if (window.pageYOffset > sticky) {
            stick_header.classList.add("header-sticky");
        } else {
            stick_header.classList.remove("header-sticky");
        }
    }

    
  },
  created: function() {
    if(this.path == 'buzz'){this.setPageHeaders();} //for pages with scroll-sticky headers
    if(this.path == 'register'){this.show_back = false;}
    this.checkLoggedIn();
  }
}


// WEBPACK FOOTER //
// ./src/pages/MainHeader/script.js